import React from "react";
import styles from "./Recruitment.module.css";
import recruitmentImg from "../../../Images/recuitement.svg"; // replace with your image

const Recruitment = () => {
  return (
    <section className={styles.recruitmentSection}>
      <div className={styles.container}>
        <div className={styles.textContent}>
          <h2>
            Revolutionize Recruitment with{" "}
            <span className={styles.highlight}>ToxBox AI</span>
          </h2>
          <p>
            Recruitment can be tedious. Sorting through hundreds of resumes
            manually is slow, prone to human error, and exhausting. ToxBox AI
            uses advanced algorithms to screen resumes instantly, extract
            relevant skills, and highlight top talent. Recruiters can now focus
            on what matters most – interviewing and hiring the right candidates.
          </p>
        </div>
        <div className={styles.imageContent}>
          <img src={recruitmentImg} alt="Recruitment illustration" />
        </div>
      </div>
    </section>
  );
};

export default Recruitment;

